<script setup lang="ts">
import { onMounted } from 'vue'
import { useUTMStore } from '@/stores/utm'

const utmStore = useUTMStore()

onMounted(() => {
  // Initialize UTM capture when component mounts
  utmStore.initUTMCapture()
})
</script>

<template>
  <!-- This component doesn't render anything visible -->
  <div style="display: none;"></div>
</template> 